export const isCurrentDay = (date: Date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);
    return today.getTime() === date.getTime();
};

export const isCurrentYear = (date: Date) => {
    const today = new Date();

    return date.getFullYear() === today.getFullYear();
};

export const isWithinLastWeek = (date: Date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);

    const timeDiff = today.getTime() - date.getTime();
    const dayMilliseconds = 1000 * 60 * 60 * 24;

    return timeDiff <= dayMilliseconds * 6;
};
